import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  // useRef — synchronous first-line guard against React strict-mode double-invoke.
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const sid = m[1];

    // Second layer of protection — sessionStorage survives full-page reloads,
    // so if the user re-lands on this page with the same one-time sid, we skip
    // re-hitting the /session endpoint (Emergent sids can only be consumed once).
    const guardKey = `wikifi-auth-sid-${sid}`;
    if (sessionStorage.getItem(guardKey)) return;
    sessionStorage.setItem(guardKey, "1");

    (async () => {
      try {
        await api.post("/auth/session", { session_id: sid });
      } catch (err) {
        // If POST failed but the cookie is already set from a prior attempt,
        // we're still authenticated — go to dashboard instead of bouncing to /login.
        try {
          await api.get("/auth/me");
        } catch {
          sessionStorage.removeItem(guardKey);
          nav("/login");
          return;
        }
      }
      // Full reload — AuthContext re-mounts without the hash, calls /auth/me,
      // reads the freshly-set cookie, and lands on Dashboard signed-in.
      window.location.replace("/dashboard");
    })();
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-[#0B1220]/10 border-t-[#0B1220] animate-spin"/>
        <p className="text-sm text-[#5B6478]">Signing you in…</p>
      </div>
    </div>
  );
}
